var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"resultHotels"},[[_c('app-filtros',{staticClass:"d-none d-md-block",attrs:{"user":_vm.user}})],(_vm.showMapHotels)?_c('Map'):_vm._e(),_c('Filtros'),_c('Hotels')],2)}
var staticRenderFns = []

export { render, staticRenderFns }